<template>
  <div class="Index bgccc padding20">
    <div class="content_center">
      <div class="searchinput textcenter mb20">
        <div>
          <el-input
            class="w550"
            placeholder="搜索产品"
            v-model="productName"
            type="search"
          ></el-input>
          <el-button @click="submitproduct" type="primary">搜索</el-button>
        </div>
      </div>
      <!-- 菜单 轮播 公告-->
      <div class="Index_news flex justify_content_between h380">
        <div class="Index_nav">
          <div
            @click="allProduct"
            class="all flex justify_content_between padding20 cursorP"
            :style="{ color: theme }"
          >
            <span>全部商品</span>
            <span
              class="el-icon-d-arrow-right"
              style="line-height: 20px"
            ></span>
          </div>
          <p style="border: 0.5px solid #e1e1e1"></p>
          <ul class="ulList">
            <li
              v-for="(item, index) in navListdata"
              :key="index"
              class="cursorP"
            >
              <div class="flex justify_content_between">
                <p>{{ item.name }}</p>
                <p style="height: 14px; width: 14px">
                  <span class="el-icon-arrow-right"></span>
                </p>
              </div>
              <dl
                class="dlList E5433D"
                :style="{ border: '1px solid ' + theme }"
              >
                <template v-if="item.children">
                  <div
                    v-for="(its, inds) in item.children"
                    :key="inds"
                    class="mtb20"
                  >
                    <dt class="ft16 D1D1D1">{{ its.name }}</dt>
                    <dd class="mt10 ft14 ddspanA" v-if="its.children">
                      <span
                        class="mr30 lineheight30"
                        v-for="(it, ind) in its.children"
                        :key="ind"
                        :class="{actives:indes == `${inds}-${ind}`}"
                        @click="navListpro(it,`${inds}-${ind}`)"
                      >
                        <a
                          href="#"
                          >{{ it.name }}</a
                        >
                      </span>
                    </dd>
                  </div>
                </template>
                <template v-else>
                  <div>暂无...</div>
                </template>
              </dl>
            </li>
          </ul>
        </div>
        <div class="Index_ban">
          <div v-if="Homerotationpicdata.length > 0">
            <el-carousel>
              <el-carousel-item
                v-for="(item, index) in Homerotationpicdata"
                :key="index"
              >
                <el-image :src="item.url" alt="" style="border-radius: 4px" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div v-else-if="Homerotationpicdata.length == 0 && isRequer">
            <EmPty
              :title="homeTitle1"
              :Htmlwidth="'200px'"
              :Htmlheight="'200px'"
            ></EmPty>
          </div>
        </div>
        <div class="Index_advnwe">
          <div
            class="flex justify_content_between flex_wrap flex_direction_row ptb10 cursorP"
          >
            <p>
              <img src="@/assets/img/public.svg" alt="" />
            </p>
            <p @click="announcementclick" class="ft14 C787878">
              <span>更多</span>
              <span class="el-icon-d-arrow-right"></span>
            </p>
          </div>
          <div>
            <div v-if="HomenoticeListdata.length > 0">
              <ul class="Index_nwes_list">
                <li
                  v-for="(item, index) in HomenoticeListdata"
                  :key="index"
                  class="ptb10 cursorP"
                  @click="homenoticedet(item)"
                >
                  <p class="c333 ft14 font_weight">{{ item.title }}</p>
                  <p
                    class="ft13 C787878 overflow_ellipsis1 h20"
                    v-html="item.content"
                  ></p>
                </li>
              </ul>
            </div>
            <div v-else-if="HomenoticeListdata.length == 0 && isRequer">
              <EmPty
                :title="homeTitle2"
                :Htmlwidth="'200px'"
                :Htmlheight="'200px'"
              ></EmPty>
            </div>
          </div>
        </div>
      </div>
      <!-- 菜单选项卡 -->
      <div class="Index_content_nav mtb20 flex">
        <ul class="ul_list">
          <li
            v-for="(item, index) in ulListPronav"
            @click="selectMainTheme(index)"
            :class="{ active: idx == index }"
            :key="index"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>
      <!-- 内容 -->
      <div
        class="Index_content"
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
      >
        <div v-if="HomeListdata.length > 0">
          <div class="ulListpro">
            <ul class="flex justify_content_between">
              <li
                @click="orderList(item.productCode)"
                v-for="(item, index) in HomeListdata"
                :key="index"
              >
                <div class="addshopcarTop">
                  <div :style="{
                    position: 'relative',
                    top: '-10px',
                    left: '-14px'
                  }">
                    <span
                      v-if="item.promotionFlag == 1"
                      :style="{
                        background: theme,
                        color: '#fff',
                        'font-size': '14px',
                        'font-weight': '600',
                        padding: '6px 10px',
                        'border-radius': '2px',
                      }"
                      >促销</span
                    >
                  </div>
                  <p style="width: 184px; height: 184px">
                    <el-image
                      :src="
                        item.pictureList &&
                        JSON.parse(item.pictureList)[0].urlAddress
                      "
                      alt=""
                      style="height: 100%; width: 100%; border-radius: 4px"
                    />
                  </p>
                  <div class="flex justify_content_between ft18 E5433D mt8">
                    <p class="font_weight"><span>¥</span>{{ item.price || 0 }}</p>
                    <p @click.stop="collectionImgs(item)">
                      <img
                        :src="item.ofenFlag ? collectactive : collectionImg"
                        alt=""
                      />
                    </p>
                  </div>
                  <div class="overflow_ellipsis2 font_weight D1D1D1 ft13">
                    {{ item.productName }}
                  </div>
                  <div style="display:flex;justify-content: space-between">
                  <div class="ft13 C787878 specs">{{ item.spec }}</div>
                  <div class="ft13 C787878 specs">{{ item.productCode }}</div>
                  </div>
                  
                </div>
                <div class="addshopcarBtto">
                  <div class="flex justify_content_between">
                    <div
                      @click.stop="goshopproduct(item)"
                      class="E5433D ft16 flex flexalignitem_center"
                    >
                      <img
                        width="16"
                        height="16"
                        src="@/assets/img/buyNow.svg"
                      />
                      <p>&nbsp;立即购买</p>
                    </div>
                    <p class="border_left"></p>
                    <div
                      @click.stop="addshopcar(item)"
                      class="E5433D ft16 flex flexalignitem_center"
                    >
                      <img
                        width="16"
                        height="16"
                        src="@/assets/img/addShopcars.svg" />
                      <p>&nbsp;加购物车</p>
                    </div>
                  </div>
                </div>
              </li>
              <li
                class="bgccc"
                style="height：0px;padding:0;margin:0px;width:224px;"
              ></li>
              <li
                class="bgccc"
                style="height：0px;padding:0;margin:0px;width:224px;"
              ></li>
              <li
                class="bgccc"
                style="height：0px;padding:0;margin:0px;width:224px;"
              ></li>
              <li
                class="bgccc"
                style="height：0px;padding:0;margin:0px;width:224px;"
              ></li>
            </ul>
          </div>
          <template>
            <div class="pageschange">
              <el-pagination
                background
                layout="total,prev, pager, next"
                :total="total"
                :current-page.sync="pageNum"
                prev-text="上一页"
                next-text="下一页"
                @current-change="HomeLists()"
              >
                <!-- @next-click="nextClick"
                  @prev-click="prevClick"
                  @current-change="currentClick" -->
              </el-pagination>
            </div>
          </template>
        </div>
        <!-- 无商品列表时 -->
        <div
          v-else-if="HomeListdata.length == 0 && isRequer"
          class="notproList textcenter mtb20"
        >
          <EmPty
            :title="homeTitle3"
            :Htmlwidth="'200px'"
            :Htmlheight="'200px'"
          ></EmPty>
        </div>
      </div>
    </div>
    <div>
      <!-- 由此边栏，回到顶部，购物车 -->
      <!-- <SideBar /> -->
    </div>
    <div v-if="visible">
      <AnnounDialog
        :visible.sync="visible"
        :noticedet="noticedet"
        @updateVisible="updateVisible"
        @resetPopupData="resetPopupData"
        @submitPopupData="submitPopupData"
        @handleClose="handleClose"
      />
    </div>
    <ResetPassword @closeModal="closePasswordModal" :visible="passwordVisible" />
  </div>
</template>
<script>
/**
 * @description: 接口
 * @param {*} ProductLevelTree 左侧菜单栏
 * @param {*} HomeList 商品列表
 * @param {*} HomerotationpicList  首页轮播
 * @param {*} OfenByfictitiousIds  商品收藏
 * @param {*} reMoveOfenByfictitiousIds  取消收藏
 * @param {*} HomereadNotice  通过id查询接口
 * @param {*} ShoppingCart 加入购物车
 * @return {*}
 * @author: txp
 */
import { mapGetters } from "vuex";
// import SideBar from '@/components/sidebar/SideBar'
import AnnounDialog from "./AnnounDialog";
import EmPty from "@/components/empty/empty";
import collectionImg from "@/assets/img/collectionImgs.svg";
import collectactive from "@/assets/img/collectactives.svg";
import ResetPassword from './resetPassword.vue'
import { Storage } from "@/utils/storage";
import {
  ProductLevelTree,
  HomeList,
  HomenoticeList,
  HomerotationpicList,
  OfenByfictitiousIds,
  reMoveOfenByfictitiousIds,
  ShoppingCart,
} from "@/api/api";
import {debounce} from '@/utils/index'
export default {
  name: "Index",
  data() {
    return {
      indes:null,//选中激活标杆
      homeTitle1: "暂无图片", //占位标题
      homeTitle2: "暂无公告",
      homeTitle3: "暂无商品",
      isRequer: false,
      collectionImg,
      collectactive,
      navListdata: [], //左侧菜单栏值
      HomeListdata: [], //商品列表
      HomenoticeListdata: [], //公告数据
      Homerotationpicdata: [], //轮播图片
      noticedet: {}, //公告具体详情
      noticeId: "", //每条公告id
      productLevelCode: "", //菜单栏编码
      productName: "", //搜索名字
      pageNum: 1,
      pageSize: 10,
      total: 0,
      visible: false, //弹框显示与隐藏
      loading: true,
      ulListPronav: [
        { title: "全部商品", id: 111 },
        // { title: "热销商品", id: 222 },
        // { title: "测试测试", id: 333 },
      ],
      idx: 0,
      passwordVisible: false,
      searchDebounce: null
    };
  },
  computed: {
    ...mapGetters({
      theme: "theme",
    }),
  },
  components: {
    // SideBar,
    AnnounDialog,
    EmPty,
    ResetPassword
  },
  created() {
    this.navList(),
      this.HomeLists(),
      this.HomenoticeLists(),
      this.HomerotationpicLists();
      this.searchDebounce = debounce(this.HomeLists,700)
  },
  mounted() {
    const resetPassword = Storage.l.get('resetPassword')
    if(resetPassword==='1') {
      this.passwordVisible = true
    }
  },
  watch: {
    productName() {
      this.searchDebounce()
    },
  },
  methods: {
    /**
     * @description: 菜单栏
     * @param {*}
     * @return {*}
     * @author: txp
     */
    navList() {
      ProductLevelTree({
        code: "",
        id: "",
        name: "",
      })
        .then((res) => {
          if (res.code == 200) {
            this.navListdata = res.result;
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$message.error(message);
        });
    },
    /**
     * @description: 商品列表
     * @param {*} productLevelCode  菜单栏查询字段
     * @param {*} productName 搜索栏查询
     * @return {*}
     * @author: txp
     */
    HomeLists() {
      this.loading = true;
      HomeList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        productLevelCode: this.productLevelCode, //菜单栏编码
        productName: this.productName, //搜索名字
      })
        .then((res) => {
          if (res.code == 200) {
            this.HomeListdata = res.result.data;
            this.total = res.result.count;
            this.loading = false;
            this.isRequer = true;
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    // nextClick(nextPageNum){
    //     this.loading = true
    //     this.pageNum=nextPageNum
    //     this.HomeLists()
    // },
    // prevClick(prevPageNum){
    //     this.loading = true
    //     this.pageNum=prevPageNum
    //     this.HomeLists()
    // },
    // currentClick(currentPageNum){
    //     this.loading = true
    //     this.pageNum=currentPageNum
    //     this.HomeLists()
    // },
    // 获取公告
    HomenoticeLists() {
      HomenoticeList({
        pageNum: this.pageNum,
        pageSize: 5,
      })
        .then((res) => {
          if (res.code == 200) {
            this.HomenoticeListdata = res.result.data;
            this.isRequer = true;
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    /**
     * @description: 公共详情,这里需要标记已读和未读，所有可标记，已读的传值获取。未读的则传参数，调接口
     * @param { string }   msgStateName  来判断
     * @param {*} noticeId 每条公告的Id
     * @author: txp
     */
    homenoticedet(item) {
      this.visible = true;
      this.noticedet = item;
    },
    // 修改是否让页面显示与隐藏的事件
    updateVisible(val) {
      this.visible = val;
    },
    // 点击取消的事件
    resetPopupData() {
      // 这里可重置数据
      this.visible = false;
    },
    // 点击确定的按钮
    async submitPopupData() {
      this.visible = false;
    },
    // 关闭弹框（头部的X）
    handleClose() {
      this.visible = false;
    },
    // 获取首页轮播图
    HomerotationpicLists() {
      HomerotationpicList()
        .then((res) => {
          this.Homerotationpicdata = res.result.data;
          this.isRequer = true;
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    // 左侧菜单栏点击
    navListpro(it,ind) {
      this.productLevelCode = it.code;
      this.indes = ind
      this.HomeLists();
    },
    // 点击切换收藏
    collectionImgs(item) {
      // 收藏
      if (item.ofenFlag != 1) {
        OfenByfictitiousIds([item.id])
          .then((res) => {
            if (res.code == 200) {
              item.ofenFlag = 1;
              this.$message.success("收藏成功");
            }
          })
          .catch((error) => {
            this.$message.error(error);
          });
      } else {
        // 取消收藏
        reMoveOfenByfictitiousIds([item.id])
          .then((res) => {
            if (res.code == 200) {
              item.ofenFlag = 0;
              this.$message.warning("取消收藏");
            }
          })
          .catch((error) => {
            this.$message.error(error);
          });
      }
    },
    // 跳转到订单详情页面
    orderList(productCode) {
      //商品编码
      this.$router.push({
        path: "/home/shopcardet",
        query: {
          productCode,
        },
      });
    },
    // 跳转到更多公告内容
    announcementclick() {
      this.$router.push("/home/main/announcement");
    },
    // 立即购买
    goshopproduct(val) {
      const dataList = [];
      let obj = {
        ...val,
        productNum: 1, //根据获取的购物车中加购的数量
        isChecked: true,
        lineType: "10",
        imgUrl: val.pictureList && val.pictureList[0].urlAddress,
      };
      dataList.push(obj);
      Storage.l.set("orderList", JSON.stringify(dataList));
      this.$router.push({
        path: "/home/shopsesttle",
      });
    },
    // 点击购物车
    addshopcar(item) {
      ShoppingCart({
        goodsCode: item.productCode,
        goodsName: item.productName,
        num: 1,
      })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(res.message);
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    // 搜索
    submitproduct() {
      this.HomeLists();
    },
    // 查看全部商品
    allProduct() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.productLevelCode = ""; //菜单栏编码
      this.productName = ""; //搜索名字
      this.HomeLists();
    },
    /**
     * @description: 商品类型的选择
     * @param {*}
     * @return {*}
     * @author: txp
     */
    selectMainTheme(index) {
      this.idx = index;
      this.HomeLists();
    },
    //关闭修改密码弹窗
    closePasswordModal() {
      this.passwordVisible = false
    }
  },
};
</script>
<style lang="scss" scoped>
.font_weight{
  span{
    font-size: 12px;
    font-weight: 400;
    padding-right: 4px;
  }
}
.Index {
  height: 100%;
  .searchinput {
    /deep/.el-input__inner {
      border-radius: 0px;
      vertical-align: middle;
      box-sizing: border-box;
      -moz-box-sizing: border-box; /* Firefox */
      -webkit-box-sizing: border-box; /* Safari */
    }
    /deep/.el-button--primary {
      border-radius: 0px;
      vertical-align: middle;
    }
  }
  .Index_news {
    height: 380px;
    .Index_nav {
      border-radius: 4px;
      width: 200px;
      background-color: #fff;
      position: relative;
      .all {
        font-size: 14px;
        line-height: 20px;
      }
      .ulList {
        height: 319px;
        overflow-y: scroll;
        overflow-x: hidden;
        li div {
          padding: 12px 20px;
          font-size: 14px;
          color: #787878;
          z-index: 1;
        }
        li .dlList {
          position: absolute;
          padding: 0px 20px;
          border-radius: 4px;
          max-width: 666px;
          width: 666px;
          max-height: 380px;
          height: 380px;
          left: 195px;
          top: 0px;
          display: none;
          z-index: 10;
          background: #fff;
          overflow-y: auto;
          overflow-x: hidden;
        }
        li:hover p {
          color: $color-primary;
        }
        li:hover dl {
          display: block;
        }
      }
      // 设置滚动条样式
      /deep/ .ulList::-webkit-scrollbar {
        width: 5px;
      }
      /deep/ .ulList::-webkit-scrollbar-track {
        background-color: #fafafa;
      }
      /deep/ .ulList::-webkit-scrollbar-thumb {
        // background: rgba(27, 140, 236, 0.5); //主题色添加
        background: $color-primary;
      }
      /deep/ .dlList::-webkit-scrollbar {
        width: 5px;
      }
      /deep/ .dlList::-webkit-scrollbar-track {
        background-color: #fafafa;
      }
      /deep/ .dlList::-webkit-scrollbar-thumb {
        // background: rgba(27, 140, 236, 0.5); //主题色添加
        background: $color-primary;
      }
    }
    .Index_ban {
      border-radius: 4px;
      width: 683px;
      margin: 0px 20px 0px 20px;
      height: 100%;
      // 轮播图
      /deep/.el-carousel__container {
        height: 380px;
      }
      /deep/ .el-carousel {
        .el-carousel__arrow--left {
          display: none;
        }
        .el-carousel__arrow--right {
          display: none;
        }
        .el-carousel__indicator--horizontal {
          display: none;
        }
      }
    }
    .Index_advnwe {
      border-radius: 4px;
      background-color: #fff;
      flex: 1;
      height: 360px;
      overflow-y: auto;
      padding: 10px;
      .Index_nwes_list {
        li {
          padding: 10px 0px;
          border-top: 1px dashed #e1e1e1;
          p {
            line-height: 21px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
  .Index_content_nav {
    .ul_list{
      display: flex;
      li {
        font-size: 16px;
        padding: 0px 20px;
        color: #333;
        font-weight: bold;
        cursor: pointer;
      }
      li:not(:last-child) {
        border-right: 2px solid #ccc;
      }
      .active{
        color: $color-primary;
      }
    }
  }
  .Index_content {
    z-index: 1000;
    .ulListpro {
      ul {
        flex-wrap: wrap;
        li {
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          width: 184px;
          border: 1xp solid #ccc;
          border-radius: 4px;
          padding: 20px 20px 14px 20px;
          background-color: #fff;
          margin-bottom: 20px;
          .addshopcarTop {
            flex: 1;
          }
          .addshopcarBtto {
            height: 20px;
            margin-top: 10px;
          }
          /deep/ .el-button {
            font-size: 10px;
            padding: 4px;
            margin: 0px;
          }
          .specs{
            height: 20px;
          }
        }
        li:hover {
          cursor: pointer;
        }
        li::after {
          content: "";
          width: 180px;
        }
      }
    }
  //分页
  .pageschange {
    margin: 10px auto 40px;
    text-align: center;
  }
  }
  /deep/.el-dialog__header {
    padding: 20px 20px 0px 20px;
  }
  // 弹框样式
  /deep/ .el-dialog__title {
    font-size: 18px;
  }
  /deep/ .el-dialog__body {
    font-size: 13px;
    padding: 20px !important;
    .dialogs p {
      line-height: 30px;
    }
  }
  // 模态框
  .pub_dialog {
    display: flex;
    justify-content: center;
    align-items: Center;
    overflow: hidden;
  }
  .ddspanA{
    a{
      color: #787878;
    }
  }
  .actives{
    a{
      color: $color-primary;
    }
  }
}
</style>